var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "navigator-centent as-flex flex-vertical main-start cross-center",
    },
    [
      _vm._l(_vm.pages, function (item, index) {
        return [
          _c(
            "div",
            {
              key: index,
              class: [
                "routeItem",
                "f-3",
                "as-flex",
                "main-start",
                "cross-center",
                item.routeName === _vm.currentPage
                  ? "is-active"
                  : "is-not-active",
              ],
              on: {
                click: function ($event) {
                  return _vm.goto(item.routeName)
                },
              },
            },
            [
              _c("div", { staticClass: "navi-img" }, [
                _c("i", {
                  class: ["icon", _vm.navi_img_mapping[item.routeName]],
                  attrs: { alt: "" },
                }),
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(item.title))]),
            ]
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }